import { useState, useEffect, useRef } from 'react';

interface QueueSSEData {
  count: number;
  estimatedWaitMinutes: number;
}

export function useQueueSSE(shopSlug: string | undefined): QueueSSEData | null {
  const [data, setData] = useState<QueueSSEData | null>(null);
  const eventSourceRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (!shopSlug) return;

    const url = `/api/shops/${shopSlug}/queue/stream`;
    const eventSource = new EventSource(url);
    eventSourceRef.current = eventSource;

    eventSource.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data) as QueueSSEData;
        setData(parsed);
      } catch {
        // ignore parse errors
      }
    };

    eventSource.onerror = () => {
      eventSource.close();
      // Reconnect after 5 seconds
      setTimeout(() => {
        if (eventSourceRef.current === eventSource) {
          eventSourceRef.current = null;
        }
      }, 5000);
    };

    return () => {
      eventSource.close();
      eventSourceRef.current = null;
    };
  }, [shopSlug]);

  return data;
}
